import { Card, Typography, Space, Row, Col, Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { ProductBgCardComponentModel } from "@services/api";
import { bxOpenSlider } from "@lib/bx24";

const guaranteeTypeMap: Record<string, string> = {
  participation: "На участие в торгах",
  execution: "На исполнение обязательств по контракту",
  returnAdvance: "На возврат аванса",
  period: "На обеспечение гарантийных обязательств",
};

const copyableConfig = {
  tooltips: false,
};

interface Props {
  product?: ProductBgCardComponentModel;
  className?: string;
}

export default function ProductBgCard({ product, className }: Props) {
  const purchaseNumber = product?.purchaseNumber || "—";
  const guaranteeType = product?.guaranteeType
    ? guaranteeTypeMap[product.guaranteeType] || product.guaranteeType
    : "—";

  const handleOpen = () => bxOpenSlider("productBg", { productId: product?.id });

  return (
    <Card className={className} bordered>
      <Row justify="space-between" align="top" gutter={16} style={{ marginBottom: 8 }}>
        <Col flex="auto">
          <Space direction="vertical" size={12} style={{ width: "100%" }}>
            <Row gutter={8} align="middle" wrap={false}>
              <Col>
                <Typography.Text type="secondary">Реестровый № торгов:</Typography.Text>
              </Col>
              <Col flex="auto">
                <Typography.Title level={5} style={{ margin: 0 }} copyable={copyableConfig}>
                  {purchaseNumber}
                </Typography.Title>
              </Col>
            </Row>
            <Row gutter={8} align="middle" wrap={false}>
              <Col>
                <Typography.Text type="secondary">Тип гарантии:</Typography.Text>
              </Col>
              <Col flex="auto">
                <Typography.Text strong>{guaranteeType}</Typography.Text>
              </Col>
            </Row>
          </Space>
        </Col>
        <Col flex="none">
          <Button type="primary" icon={<EditOutlined />} onClick={handleOpen}>
            Править заявку
          </Button>
        </Col>
      </Row>
    </Card>
  );
}
